import React, { ReactElement } from "react";
import {
  deselectUniqueItemsValue,
  enums,
  selectUniqueItemsValue
} from "../utils";
import { WidgetProps } from "@rjsf/utils";
import CheckboxWidget from "./CheckboxWidget";

export default function CheckboxesWidget(props: WidgetProps): ReactElement {
  const { enumOptions, enumDisabled } = enums(props);

  const selectedValues = props.value as string[];

  // Produces change handler for each individual checkbox
  const handleChange = (value: string, index: number) => (checked: boolean) =>
    props.onChange(
      checked
        ? selectUniqueItemsValue(value, index, selectedValues)
        : deselectUniqueItemsValue(value, selectedValues)
    );

  return (
    <>
      {enumOptions.map(({ value, label }, index) => (
        <CheckboxWidget
          hideDescription // We show description in the form field
          {...props}
          key={value}
          label={label}
          value={selectedValues.includes(value)}
          disabled={enumDisabled?.includes(value) ?? false}
          onChange={handleChange(value, index)}
        />
      ))}
    </>
  );
}
